import { createFileRoute } from "@tanstack/react-router";
import { PersonalHome } from "@/features/me/PersonalHome";

export const Route = createFileRoute("/app/")({ component: PersonalHome });
